import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  styled,
} from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr, enGB } from "date-fns/locale";
import { DatePicker } from "@mui/x-date-pickers";

import PropTypes from "prop-types";

//get DispensingLanguage
const DispensingLanguage = JSON.parse(
  localStorage.getItem("DispensingLanguage"),
);
const lan = localStorage.getItem("LangCode");
const menukey = "patients";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialog-paper": {
    minWidth: "80%",
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          size="large"
        >
          {/* <CloseIcon /> */}
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const AnthropometricsTab = ({
  open,
  handleClose,
  anthropometricData,
  handleChangeByTabs,
  handleSubmitByTabs,
  handleRDateChangeByTabs,
  errorAnthropometricsData,
}) => {
  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          {DispensingLanguage[lan][menukey]["ANTHROPOMETRICS ENTRY"]} -{" "}
          {anthropometricData.id
            ? DispensingLanguage[lan][menukey]["EDIT"]
            : DispensingLanguage[lan][menukey]["ADD"]}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={2}>
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={lan === "en_GB" ? enGB : fr}
              >
                <DatePicker
                  label={DispensingLanguage[lan][menukey]["Date"]}
                  value={anthropometricData.date || new Date()}
                  inputFormat="dd/MM/yyyy"
                  onChange={(e) =>
                    handleRDateChangeByTabs(e, "date", "anthropometricsData")
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={5}>
              <TextField
                variant="standard"
                required
                error={!!errorAnthropometricsData.weight}
                helperText={errorAnthropometricsData.weight}
                id="weight"
                type="number"
                name="weight"
                label={DispensingLanguage[lan][menukey]["Weight in KG"]}
                value={anthropometricData.weight ?? ""}
                fullWidth
                autoComplete="family-name"
                onChange={(e) => handleChangeByTabs(e, "anthropometricsData")}
              />
            </Grid>
            <Grid item xs={12} sm={5}>
              <TextField
                variant="standard"
                required
                error={!!errorAnthropometricsData.height}
                helperText={errorAnthropometricsData.height}
                id="height"
                type="number"
                name="height"
                label={DispensingLanguage[lan][menukey]["Height in CM"]}
                value={anthropometricData.height ?? ""}
                fullWidth
                autoComplete="family-name"
                onChange={(e) => handleChangeByTabs(e, "anthropometricsData")}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            className="float-start"
            variant="contained"
            color="gray"
            onClick={handleClose}
          >
            {DispensingLanguage[lan][menukey]["Cancel"]}
          </Button>
          <Button
            autoFocus
            className="me-2 float-start"
            variant="contained"
            color="primary"
            onClick={() => handleSubmitByTabs("anthropometricsData")}
          >
            {DispensingLanguage[lan][menukey]["Save changes"]}
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
};

export default AnthropometricsTab;
